import { useMutation } from '@tanstack/react-query';
import { createGoalsWithIds } from 'shared/services/backend-api';
import { NewGoalWithID } from 'shared/types/goal';

export const useCreateGoalsWithIdsMutation = () =>
  useMutation({
    mutationFn: async (goals: NewGoalWithID[]) => createGoalsWithIds(goals),
  });
